import { APP_INITIALIZER } from '@angular/core';
import { AppConfig }       from './app.config';
//import { HttpModule }      from '@angular/http';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
// import { NgxSocialLoginModule } from 'ngx-social-login';
import { CustomHttpInterceptor } from './interceptor/custom-http.interceptor';
import { BrowserModule } from '@angular/platform-browser';
import { SharedServiceModule } from './shared-service/shared-service.module';
import { MaterialModule } from './shared/components/material.module';
import { SharedModule } from './shared/shared.module';
// import { ConfigResolverService } from './resolvers/configResolverService';
// import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ShippingComponent } from './shipping/shipping.component';
import { DailyDoseComponent } from './daily-dose/daily-dose.component';
import { CancellationPolicyComponent } from './cancellation-policy/cancellation-policy.component';
//import { ServiceWorkerModule } from '@angular/service-worker';
//import { environment } from '../environments/environment';


//Add this function as initiating load method first
function initConfig(config: AppConfig){
  return () => config.load()
}

@NgModule({
  declarations: [
    AppComponent,
    ShippingComponent,
    DailyDoseComponent,
    CancellationPolicyComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MaterialModule,
    HttpClientModule,
    // FontAwesomeModule,
    SharedModule.forRoot(),
    SharedServiceModule.forRoot(),
    // NgxSocialLoginModule.init({
    //   google: {
    //     client_id: '537795635068-1r7tjvhihp06f6shdsq93044shtcqdsm.apps.googleusercontent.com'
    //   },
    //   facebook: {
    //     initOptions: {
    //       appId: '458895534798583'
    //     }
    //   }
    // }),
    // MathJaxModule.forRoot({
    //   version: '2.7.5',
    //   config: 'TeX-AMS_HTML',
    //   hostname: 'cdnjs.cloudflare.com'
    // })

   // ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),


  ],
  providers: [
    AppConfig,
    { provide: APP_INITIALIZER, useFactory: initConfig, deps: [AppConfig], multi: true },
  //  GlobalService,
    { provide: HTTP_INTERCEPTORS, useClass: CustomHttpInterceptor, multi: true },
    // ConfigResolverService
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
